class SitemapDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('.sitemap-drawer__overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('.sitemap-drawer__close').addEventListener('click', this.close.bind(this));
    this.setHeaderSitemapButtonAccessibility();
  }

  setHeaderSitemapButtonAccessibility() {
    const sitemapButton = document.querySelector('#sitemap-button');
    sitemapButton.setAttribute('role', 'button');
    sitemapButton.setAttribute('aria-haspopup', 'dialog');
    sitemapButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(sitemapButton);
    });
    sitemapButton.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(sitemapButton);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.querySelector('.sitemap-drawer__inner');
        const focusElement = this.querySelector('.sitemap-drawer__inner') || this.querySelector('.sitemap-drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    // document.querySelector('.sitemap-drawer').style.display = "block"

  }

  close() {
    this.classList.remove('active', 'animate');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('sitemap-drawer', SitemapDrawer);



